module.exports = __webpack_public_path__ + "img/icon-wallet.e20ccfa9.svg";